var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import styles from './ApiCheck.module.scss';
import { serviceCreator } from 'src/services/helpers/serviceCreator';
import { E_REQUEST_METHOD } from 'src/services/ServicesHelpers';
import { ApiStatusItem } from 'src/ui/views/apiCheck/components/ApiStatusItem';
export var ApiCheck = function (props) {
    var realm = props.realm, apisStatus = props.apisStatus, pingApis = props.pingApis;
    var _a = useState(false), configFileExist = _a[0], setConfigFileExist = _a[1];
    useEffect(function () {
        if (realm) {
            serviceCreator(E_REQUEST_METHOD.GET, "".concat(window.env.BASE_PATH, "/scripts/env.js"), false)
                .callAPI()
                .then(function (res) {
                setConfigFileExist(res.status === 200);
            });
            pingApis();
        }
    }, [realm]);
    return (_jsxs("div", __assign({ className: styles.ApiCheckWrapper }, { children: [_jsx("h2", __assign({ className: styles.ApiCheckWrapperTitle }, { children: "Environment" })), _jsx("ul", __assign({ className: styles.ApiCheckList }, { children: _jsx(ApiStatusItem, { name: 'Configuration fetching', isValid: configFileExist }) })), _jsx("h2", __assign({ className: styles.ApiCheckWrapperTitle }, { children: "URL checks" })), apisStatus && (_jsxs("ul", __assign({ className: styles.ApiCheckList }, { children: [_jsx(ApiStatusItem, __assign({}, apisStatus.cases)), _jsx(ApiStatusItem, __assign({}, apisStatus.config)), _jsx(ApiStatusItem, __assign({}, apisStatus.iam)), _jsx(ApiStatusItem, __assign({}, apisStatus.keycloak)), _jsx(ApiStatusItem, __assign({}, apisStatus.search)), _jsx(ApiStatusItem, __assign({}, apisStatus.sse))] })))] })));
};
